module.exports = __webpack_public_path__ + "static/media/palm-tree.2f173061.fbx";